import {SUBREDDITS_LIST_ERROR, SUBREDDITS_LIST_REQUEST, SUBREDDITS_LIST_SUCCESS} from '../actions';

export default(state = {
    items: [],
    loading: true
}, action) => {
    switch (action.type) {
        case SUBREDDITS_LIST_ERROR:
        case SUBREDDITS_LIST_SUCCESS:
            const {
                children,
                ...data
            } = action.payload.data;
            return {
                ...data,
                items: state
                    .items
                    .concat(children),
                loading: false
            };
        case SUBREDDITS_LIST_REQUEST:
            return {
                ...state,
                loading: true
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/apps/client-reddit/reducers/subreddits.js